import CustomHeader from '@src/components/common/appHeader/CustomHeader';
import './weddingHallContractCheckInfo.scss'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PinchZoom from '@src/components/common/pinchZoom/PinchZoom';

const WeddingHallContractCheckInfo = ({openModalInfo,closeModal}) => {
    return (
        <>
        {openModalInfo.open &&
        <div className='page-weddinghall-contract-check hide-scroll'>
            <div className='modal-inner'>
                <CustomHeader goBack={()=>closeModal()} close={()=>closeModal()}/>
                <div className='modal-contents'>
                <h2 className='title bold'>{openModalInfo.title}</h2>
                <div>
                    {openModalInfo.target === 'string' &&
                    <p className='additional-info'>{openModalInfo.src || ''}</p>
                    }
                    {openModalInfo.target === 'img' &&
										<TransformWrapper maxScale={3}>
      								<TransformComponent>
												<div style={{backgroundImage: `url(${openModalInfo.src})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: `calc(100vw - 40px)`, height: '70vh'}}></div>
                    {/* <img 
                        className='contract-img'
                        src={openModalInfo.src || ''}
                        alt={openModalInfo.title}
                    /> */}
											</TransformComponent>
										</TransformWrapper>
                    }
                </div>
                <button 
                    className='btn btn-full btn-red500 btn-giant btn-bottom-fixed'
                    onClick={()=>closeModal()}
                >
                    확인
                </button>   
                </div>
            </div>
        </div>
        }
        </>
       
    );
};

export default WeddingHallContractCheckInfo;